export default "__VITE_ASSET__PI4UYtV$__"